var React = require('react');

function BlackSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.09082 14.2002C8.43555 14.2002 9.70117 13.8135 10.7734 13.1455L14.3945 16.7666C14.6846 17.0566 15.0801 17.1973 15.4844 17.1973C16.3369 17.1973 16.9785 16.5381 16.9785 15.6855C16.9785 15.2988 16.8467 14.9121 16.5479 14.6221L12.9619 11.0273C13.7002 9.91113 14.1221 8.58398 14.1221 7.16016C14.1221 3.29297 10.958 0.120117 7.09082 0.120117C3.22363 0.120117 0.0507812 3.28418 0.0507812 7.16016C0.0507812 11.0273 3.22363 14.2002 7.09082 14.2002ZM7.09082 12.0557C4.39258 12.0557 2.18652 9.84961 2.18652 7.16016C2.18652 4.4707 4.39258 2.26465 7.09082 2.26465C9.78027 2.26465 11.9863 4.4707 11.9863 7.16016C11.9863 9.84961 9.78027 12.0557 7.09082 12.0557Z","fill":"#222224"}));
}

BlackSearch.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = BlackSearch;

BlackSearch.default = BlackSearch;
